import { render, staticRenderFns } from "./EcosystemSelect.vue?vue&type=template&id=1bca02d8"
import script from "./EcosystemSelect.vue?vue&type=script&lang=js"
export * from "./EcosystemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports